module.exports = "/images/alert-warn.svg?eec38935970c9895fbc7361a8ce799c9";